import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const EMPTY = { business_name: "", admin_name: "", admin_email: "", admin_password: "", plan_id: "", free_account: true };

export const NewBusinessDialog = ({ open, onOpenChange, plans, onDone }) => {
  const [f, setF] = useState(EMPTY);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/super/businesses", f);
      toast.success("Business created");
      setF(EMPTY);
      onOpenChange(false);
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="new-business-dialog">
        <DialogHeader><DialogTitle>New business account</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {[["business_name", "Business name"], ["admin_name", "Admin name"], ["admin_email", "Admin email"], ["admin_password", "Temporary password"]].map(([k, l]) => (
            <div key={k} className="space-y-1.5">
              <Label>{l}</Label>
              <Input required value={f[k]} onChange={set(k)} type={k === "admin_email" ? "email" : "text"} minLength={k === "admin_password" ? 6 : undefined} data-testid={`new-business-${k}-input`} />
            </div>
          ))}
          <div className="space-y-1.5">
            <Label>Plan</Label>
            <Select value={f.plan_id} onValueChange={(v) => setF({ ...f, plan_id: v })}>
              <SelectTrigger data-testid="new-business-plan-select"><SelectValue placeholder="Choose plan" /></SelectTrigger>
              <SelectContent>{plans.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <label className="flex items-center justify-between rounded-lg bg-amber-50 p-3 text-sm font-medium">
            Free account (no payment required)
            <Switch checked={f.free_account} onCheckedChange={(v) => setF({ ...f, free_account: v })} data-testid="new-business-free-switch" />
          </label>
          <Button type="submit" className="w-full rounded-full" disabled={!f.plan_id} data-testid="new-business-submit-btn">Create</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
